import { render, staticRenderFns } from "./HelpdeskStep.vue?vue&type=template&id=46713bc4&"
import script from "./HelpdeskStep.vue?vue&type=script&lang=ts&"
export * from "./HelpdeskStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46713bc4')) {
      api.createRecord('46713bc4', component.options)
    } else {
      api.reload('46713bc4', component.options)
    }
    module.hot.accept("./HelpdeskStep.vue?vue&type=template&id=46713bc4&", function () {
      api.rerender('46713bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LobbySteps/HelpdeskStep.vue"
export default component.exports